__turbopack_context__.v({
  "breadcrumb": "breadcrumbs-module__s0N6VW__breadcrumb",
  "breadcrumbLink": "breadcrumbs-module__s0N6VW__breadcrumbLink",
  "currentBreadcrumb": "breadcrumbs-module__s0N6VW__currentBreadcrumb",
  "darkBackground": "breadcrumbs-module__s0N6VW__darkBackground",
});
